export const getContactsImportPageNextjsUrl = () => '/contacts/import'
